import axios from '../axios'

/*
 * 纠纷订单信息列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/disputeOrder/selectByPage',
        method: 'post',
        data
    })
}



export const selectByMemberId = (params) => {
    return axios({
        url: '/technologyApply/selectByMemberId',
        method: 'get',
        params
    })
}

export const batchReject = (data) => {
    return axios({
        url: '/technologyApply/batchReject',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/oms/disOrder.js